import React from 'react';

import LogoDesktop from './components/LogoDesktop';
import LogoMobile from './components/LogoMobile';
import LogoPrideDesktop from './components/LogoPrideDesktop';
import LogoPrideMobile from './components/LogoPrideMobile';
import LogoZillowPride from './components/LogoZillowPride';

// styles
import {
  StyledHeaderNavigationLogoDesktop,
  StyledHeaderNavigationLogoMobile,
  StyledLogoAnchor,
  StyledLogoPrideMobile,
  StyledLogoZillowPrideMobile,
  StyleLogoZillowPrideDesktop,
  StyleLogoZRMPrideDesktop,
} from './style';

const HeaderNavigationLogo = ({
  // true renders zrm logo
  // false renders zillow logo
  altLogo,
  displayPrideLogo = false,
  isMobile,
  to,
}: {
  altLogo: boolean;
  displayPrideLogo?: boolean;
  isMobile: boolean;
  to: string;
}) => {
  const renderMobilePrideLogos = (useAltLogo: boolean) => {
    return (
      <>
        {useAltLogo ? (
          <StyledLogoPrideMobile>
            <LogoPrideMobile />
          </StyledLogoPrideMobile>
        ) : (
          <StyledLogoZillowPrideMobile>
            <LogoZillowPride />
          </StyledLogoZillowPrideMobile>
        )}
      </>
    );
  };

  const renderDesktopPrideLogos = (useAltLogo: boolean) => {
    return (
      <>
        {useAltLogo ? (
          <StyleLogoZRMPrideDesktop>
            <LogoPrideDesktop />
          </StyleLogoZRMPrideDesktop>
        ) : (
          <StyleLogoZillowPrideDesktop>
            <LogoZillowPride />
          </StyleLogoZillowPrideDesktop>
        )}
      </>
    );
  };

  if (isMobile) {
    return (
      <StyledHeaderNavigationLogoMobile alternate={altLogo}>
        <StyledLogoAnchor href={to} aria-label="zillow rental manager home page">
          {displayPrideLogo ? renderMobilePrideLogos(altLogo) : <LogoMobile alternate={altLogo} />}
        </StyledLogoAnchor>
      </StyledHeaderNavigationLogoMobile>
    );
  }
  return (
    <StyledHeaderNavigationLogoDesktop>
      <StyledLogoAnchor href={to} aria-label="zillow rental manager home page">
        {displayPrideLogo ? renderDesktopPrideLogos(altLogo) : <LogoDesktop alternate={altLogo} />}
      </StyledLogoAnchor>
    </StyledHeaderNavigationLogoDesktop>
  );
};

export default HeaderNavigationLogo;
